export default {
  clean: () => import("/tmp/build_3dff4878/layouts/clean.vue"),
  default: () => import("/tmp/build_3dff4878/layouts/default.vue")
}